import imgCharizard from "../images/pokemon/mega_charizard.png";
import imgVenusaur from "../images/pokemon/venusaur.png";
import imgKingambit from "../images/pokemon/kingambit.png";
import imgSneasler from "../images/pokemon/sneasler.png";
import imgWhimsicott from "../images/pokemon/whimsicott.png";
import imgGarchomp from "../images/pokemon/garchomp.png";

export const POKEMON_CHAMPIONS_PROFILE = [
	{
		slug: "charizard",
		name: "Mega Charizard Y",
		types: ["Fire", "Flying"],
		image: imgCharizard,
		nature: "Modest",
		heldItem: "Charizardite Y",
		ability: "Blaze & Drought",
		statsNote: "Total stats are before Mega Evolution.",
		moves: [
			{
				name: "Heat Wave",
				category: "Special Attack",
				type: "Fire",
				power: "95",
				accuracy: "90%",
			},
			{
				name: "Solar Beam",
				category: "Special Attack",
				type: "Grass",
				power: "120",
				accuracy: "100%",
			},
			{
				name: "Protect",
				category: "Status",
				type: "Normal",
				power: "—",
				accuracy: "—",
			},
			{
				name: "Weather Ball",
				category: "Special Attack",
				type: "Normal",
				power: "50",
				accuracy: "100%",
			},
		],
		totalStats: [
			{ label: "HP", value: 155 },
			{ label: "Atk", value: 93 },
			{ label: "Def", value: 98 },
			{ label: "SpA", value: 177 },
			{ label: "SpD", value: 105 },
			{ label: "Spe", value: 152 },
		],
		evSpread: [
			{ label: "HP", value: 2 },
			{ label: "Atk", value: 0 },
			{ label: "Def", value: 0 },
			{ label: "SpA", value: 32 },
			{ label: "SpD", value: 0 },
			{ label: "Spe", value: 32 },
		],
	},
	{
		slug: "venusaur",
		name: "Venusaur",
		types: ["Grass", "Poison"],
		image: imgVenusaur,
		nature: "Modest",
		heldItem: "Sitrus Berry",
		ability: "Chlorophyll",
		moves: [
			{
				name: "Sludge Bomb",
				category: "Special Attack",
				type: "Poison",
				power: "90",
				accuracy: "100%",
			},
			{
				name: "Giga Drain",
				category: "Special Attack",
				type: "Grass",
				power: "75",
				accuracy: "100%",
			},
			{
				name: "Solar Beam",
				category: "Special Attack",
				type: "Grass",
				power: "120",
				accuracy: "100%",
			},
			{
				name: "Protect",
				category: "Status",
				type: "Normal",
				power: "—",
				accuracy: "—",
			},
		],
		totalStats: [
			{ label: "HP", value: 155 },
			{ label: "Atk", value: 91 },
			{ label: "Def", value: 103 },
			{ label: "SpA", value: 167 },
			{ label: "SpD", value: 122 },
			{ label: "Spe", value: 132 },
		],
		evSpread: [
			{ label: "HP", value: 0 },
			{ label: "Atk", value: 0 },
			{ label: "Def", value: 0 },
			{ label: "SpA", value: 32 },
			{ label: "SpD", value: 2 },
			{ label: "Spe", value: 32 },
		],
	},
	{
		slug: "kingambit",
		name: "Kingambit",
		types: ["Dark", "Steel"],
		image: imgKingambit,
		nature: "Brave",
		heldItem: "Chople Berry",
		ability: "Defiant",
		moves: [
			{
				name: "Kowtow Cleave",
				category: "Physical Attack",
				type: "Dark",
				power: "85",
				accuracy: "—",
			},
			{
				name: "Sucker Punch",
				category: "Physical Attack",
				type: "Dark",
				power: "70",
				accuracy: "100%",
			},
			{
				name: "Iron Head",
				category: "Physical Attack",
				type: "Steel",
				power: "80",
				accuracy: "100%",
			},
			{
				name: "Protect",
				category: "Status",
				type: "Normal",
				power: "—",
				accuracy: "—",
			},
		],
		totalStats: [
			{ label: "HP", value: 177 },
			{ label: "Atk", value: 205 },
			{ label: "Def", value: 140 },
			{ label: "SpA", value: 80 },
			{ label: "SpD", value: 137 },
			{ label: "Spe", value: 63 },
		],
		evSpread: [
			{ label: "HP", value: 2 },
			{ label: "Atk", value: 32 },
			{ label: "Def", value: 0 },
			{ label: "SpA", value: 0 },
			{ label: "SpD", value: 32 },
			{ label: "Spe", value: 0 },
		],
	},
	{
		slug: "sneasler",
		name: "Sneasler",
		types: ["Fighting", "Poison"],
		image: imgSneasler,
		nature: "Jolly",
		heldItem: "White Herb",
		ability: "Unburden",
		moves: [
			{
				name: "Fake Out",
				category: "Physical Attack",
				type: "Normal",
				power: "40",
				accuracy: "100%",
			},
			{
				name: "Close Combat",
				category: "Physical Attack",
				type: "Fighting",
				power: "120",
				accuracy: "100%",
			},
			{
				name: "Dire Claw",
				category: "Physical Attack",
				type: "Poison",
				power: "80",
				accuracy: "100%",
			},
			{
				name: "Protect",
				category: "Status",
				type: "Normal",
				power: "—",
				accuracy: "—",
			},
		],
		totalStats: [
			{ label: "HP", value: 157 },
			{ label: "Atk", value: 182 },
			{ label: "Def", value: 80 },
			{ label: "SpA", value: 54 },
			{ label: "SpD", value: 100 },
			{ label: "Spe", value: 189 },
		],
		evSpread: [
			{ label: "HP", value: 2 },
			{ label: "Atk", value: 32 },
			{ label: "Def", value: 0 },
			{ label: "SpA", value: 0 },
			{ label: "SpD", value: 0 },
			{ label: "Spe", value: 32 },
		],
	},
	{
		slug: "whimsicott",
		name: "Whimsicott",
		types: ["Grass", "Fairy"],
		image: imgWhimsicott,
		nature: "Modest",
		heldItem: "Focus Sash",
		ability: "Prankster",
		moves: [
			{
				name: "Moonblast",
				category: "Special Attack",
				type: "Fairy",
				power: "95",
				accuracy: "100%",
			},
			{
				name: "Tailwind",
				category: "Status",
				type: "Flying",
				power: "—",
				accuracy: "—",
			},
			{
				name: "Encore",
				category: "Status",
				type: "Normal",
				power: "—",
				accuracy: "100%",
			},
			{
				name: "Protect",
				category: "Status",
				type: "Normal",
				power: "—",
				accuracy: "—",
			},
		],
		totalStats: [
			{ label: "HP", value: 135 },
			{ label: "Atk", value: 78 },
			{ label: "Def", value: 107 },
			{ label: "SpA", value: 141 },
			{ label: "SpD", value: 95 },
			{ label: "Spe", value: 168 },
		],
		evSpread: [
			{ label: "HP", value: 0 },
			{ label: "Atk", value: 0 },
			{ label: "Def", value: 2 },
			{ label: "SpA", value: 32 },
			{ label: "SpD", value: 0 },
			{ label: "Spe", value: 32 },
		],
	},
	{
		slug: "garchomp",
		name: "Garchomp",
		types: ["Dragon", "Ground"],
		image: imgGarchomp,
		nature: "Jolly",
		heldItem: "Soft Sand",
		ability: "Rough Skin",
		moves: [
			{
				name: "Earthquake",
				category: "Physical Attack",
				type: "Ground",
				power: "100",
				accuracy: "100%",
			},
			{
				name: "Dragon Claw",
				category: "Physical Attack",
				type: "Dragon",
				power: "80",
				accuracy: "100%",
			},
			{
				name: "Rock Slide",
				category: "Physical Attack",
				type: "Rock",
				power: "75",
				accuracy: "90%",
			},
			{
				name: "Protect",
				category: "Status",
				type: "Normal",
				power: "—",
				accuracy: "—",
			},
		],
		totalStats: [
			{ label: "HP", value: 185 },
			{ label: "Atk", value: 182 },
			{ label: "Def", value: 115 },
			{ label: "SpA", value: 90 },
			{ label: "SpD", value: 105 },
			{ label: "Spe", value: 169 },
		],
		evSpread: [
			{ label: "HP", value: 2 },
			{ label: "Atk", value: 32 },
			{ label: "Def", value: 0 },
			{ label: "SpA", value: 0 },
			{ label: "SpD", value: 0 },
			{ label: "Spe", value: 32 },
		],
	},
];
